// app/providers.js
'use client';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { useEffect } from 'react';

// if (typeof window !== 'undefined') {
//   posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
//     api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
//     person_profiles: 'identified_only',
//   })
// }

export function CSPostHogProvider({ children }: { children: React.ReactNode }) {
  /**
   * @description Why use a useEffect hook to initialize PostHog?
   * https://posthog.com/docs/libraries/next-js#why-use-a-useeffect-hook-to-initialize-posthog
   */
  useEffect(() => {
    if (process.env.NEXT_PUBLIC_POSTHOG_KEY) {
      posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
        api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
        capture_pageview: false,
        person_profiles: 'identified_only',
      });
    } else {
      console.error('there is no env.NEXT_PUBLIC_POSTHOG_KEY');
    }
  }, []);

  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
